import { useState } from 'preact/hooks';
import { forgotPassword } from '@/api';
import css from './AuthScreen.module.css';

export function ForgotForm({ onBack }) {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setSuccess('');
    setSubmitting(true);
    try {
      await forgotPassword(email);
      setSuccess('Инструкции отправлены на указанный e-mail');
    } catch (err) {
      setError(err.message || 'Ошибка отправки');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <form class={css.form} onSubmit={handleSubmit} noValidate>
      <h2 class={css.title}>Восстановление пароля</h2>
      <p class={css.hint}>
        Введите e-mail, указанный при регистрации. Мы отправим ссылку для сброса пароля.
      </p>
      <div class={css.field}>
        <label>E-mail</label>
        <input
          type="email"
          required
          placeholder="email@company.ru"
          value={email}
          onInput={(e) => setEmail(e.target.value)}
        />
      </div>
      {error && (
        <div class={css.error} role="alert">
          {error}
        </div>
      )}
      {success && <div class={css.success}>{success}</div>}
      <button class={css.submit} type="submit" disabled={submitting}>
        {submitting ? 'Отправляем…' : 'Отправить'}
      </button>
      <div class={css.links}>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onBack();
          }}
        >
          Вернуться ко входу
        </a>
      </div>
    </form>
  );
}
